import React, { Fragment } from "react";
import MiniCarHero from "../common/MiniCarHero";
import { Container } from "../../../../../../common-deprecated/styles/v2/toyota/globals/Container";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as ServiceStyles from "../../../../../../common-deprecated/styles/v2/toyota/custom/services/SharedService";
import * as BasketStyles from "../../../../../../common-deprecated/styles/v2/toyota/custom/basket/Basket";
import useServices from "../../../hooks/services/useServices";
import DisclaimerContainer from "../common/disclaimer/DisclaimerContainer";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import BasketFinanceTogglePanel from "../common/basket-financetoggle-panel/BasketFinanceTogglePanel";
import Basket from "../common/basket/Basket";
import SidebarWrapper from "../../../../../../common-deprecated/components/SidebarWrapper";
import BottomNavigation from "../common/nav/BottomNavigation";
import { GreyBackground } from "../../../../../../common-deprecated/styles/toyota/Background";
import { ServiceTypeEnum } from "../../../../../../common-deprecated/types/SettingsType";
import TradeInService from "./TradeInService";
import FinanceService from "./FinanceService";
import InsuranceService from "./InsuranceService";
import BannerService from "./BannerService";
import ServiceProductService from "./ServiceProductService";
import { NAV_HEIGHT } from "../../../../../../common-deprecated/styles/v2/toyota/components/Navigation";
import EasyKanzenService from "./EasyKanzenService";

import { useBnbSelector } from "../../../redux/store";
import Finance from "../step-customize/main-content/Finance";
import Insurance from "../step-customize/main-content/Insurance";

const ServicesContainer = (): JSX.Element => {
    const { services } = useServices();
    const description = useBnbOptionalLabel("servicesDescription");
    const { showFinanceInsuranceInPage, enableFinanceCompare } = useBnbSelector((state) => state.bnbSettings);

    const components = services
        .map((service) => {
            if (service.type === ServiceTypeEnum.Tradein) return <TradeInService />;
            if (service.type === ServiceTypeEnum.Finance)
                return showFinanceInsuranceInPage || enableFinanceCompare ? (
                    <Finance showIntroduction={!enableFinanceCompare} />
                ) : (
                    <FinanceService />
                );
            if (service.type === ServiceTypeEnum.Insurance)
                return showFinanceInsuranceInPage || enableFinanceCompare ? (
                    <Insurance showIntroduction={!enableFinanceCompare} />
                ) : (
                    <InsuranceService />
                );
            if (service.type === ServiceTypeEnum.Banner) return <BannerService />;
            if (service.type === ServiceTypeEnum.Serviceplans) return <ServiceProductService />;
            if (service.type === ServiceTypeEnum.Financepacks) return <EasyKanzenService />;
            return null;
        })
        .filter((service) => !!service);
    return (
        <>
            <Container mt={5}>
                <MiniCarHero showChangeLink />
            </Container>
            <GreyBackground pt={4}>
                <Container pt={5}>
                    <Flex.Row justifyContent="flex-start">
                        <Flex.Col width={{ xs: 1, lg: 2 / 3 }}>
                            <ServiceStyles.IntroductionWrapper>
                                <Type.H2 headingType="gamma">
                                    <BnbLabel label="servicesIntroduction" />
                                </Type.H2>
                                {description && (
                                    <ServiceStyles.Description dangerouslySetInnerHTML={{ __html: description }} />
                                )}
                            </ServiceStyles.IntroductionWrapper>

                            {components.map(
                                (component, index) =>
                                    !!component && (
                                        // eslint-disable-next-line react/no-array-index-key
                                        <Fragment key={index}>{component}</Fragment>
                                    ),
                            )}

                            {components.length < 1 && (
                                <Type.H2 mb={4}>
                                    <BnbLabel label="noServices" />
                                </Type.H2>
                            )}

                            <BottomNavigation />
                        </Flex.Col>
                        <Flex.Col display={{ xs: "none", lg: "block" }} width={1 / 3} position="relative">
                            <SidebarWrapper top={NAV_HEIGHT} paddingTop={BasketStyles.BASKET_HEADER_TOP_MARGIN}>
                                <BasketStyles.BasketHeader>
                                    <BasketFinanceTogglePanel />
                                </BasketStyles.BasketHeader>
                                <Basket attached />
                            </SidebarWrapper>
                        </Flex.Col>
                    </Flex.Row>
                </Container>
            </GreyBackground>
            <GreyBackground pt={4} pb={4}>
                <Container>
                    <DisclaimerContainer showGenericFinanceDisclaimer hasDarkBackground />
                </Container>
            </GreyBackground>
        </>
    );
};

export default ServicesContainer;
